module.exports = new __parcel__URL__("GT_P_2_002.3bf47496.json").toString();